<template>
    <div>
        <div class="addmember">
            <span class="mbtb">会员卡充值</span>
        </div>
        <div style="width: 90%;margin: auto;margin-top: 30px;">
            <div class="bkmb">
                <span style="line-height: 25px;">{{member.memberName}}</span>
                <span style="width: 30%;line-height: 25px;margin-left: 8px">{{ member.phone }}</span>
            </div>
            <div class="cz-mcs">
                <span class="cz-mcs-bt">充值会员卡</span>
                <div class="cz-mc">
                    <el-radio-group v-model="mcId" @change="setCard(mcId)">
                        <el-radio :label="mc.id" class="radioitem" v-for="mc in mcs">
                            <div class="czcard-name">
                                <span class="mcname">{{mc.cardName}}</span>
                                <span class="mcbalance">余额: {{mc.balance}}</span>
                                <span class="mcgive">赠送金: {{mc.giveBalance}}</span>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="cz-mcs">
                <div class="mc-je">
                    <span>充值金额</span>
                    <el-input v-model="totalAmount" size="small" :disabled="mc.changeAmount==1"
                              placeholder="请输入充值金额" class="ki"></el-input>
                    <div v-if="mc&&mc.id">
                        <span class="xuanzebtn" @click="setEmp">选择+</span>
                    </div>
                </div>
                <div class="mc-je">
                    <span>赠送金额</span>
                    <el-input v-model="giveAmount" size="small" placeholder="请输入赠送金额" class="ki"></el-input>
                </div>
            </div>
            <div class="mc-emps" v-if="this.emps.length>0">
                <div class="mc-emp-bt">
                    <span>员工名称</span>
                    <span style="padding-left: 17px">业绩</span>
                </div>
                <div class="mc-emp" v-for="item in this.emps">
                    <span>{{item.empName}}</span>
                    <el-input v-model="item.ach" size="mini" style="width: 50%;"></el-input>
                </div>
            </div>
        </div>
        <div class="jiesuan-btn">
            <van-button type="default" class="jiesuanbtn" @click="jiesuancz()">结算</van-button>
        </div>
        <van-popup v-model="empShow" position="bottom" closeable lock-scroll overlay>
            <div>
                <span style="display: block;font-size: 15px;text-align: center;height: 45px;line-height: 45px;border-bottom: #e5e5e5 solid 1px">选择员工</span>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                            <span class="empname" :class="{hui: emp.check}"
                                  @click="setEmps(emp,1)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                            <span class="empname" :class="{hui: emp.check}"
                                  @click="setEmps(emp,2)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                            <span class="empname" :class="{hui: emp.check}"
                                  @click="setEmps(emp,3)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div style="width: 100%;height: 32px;font-size: 18px;background-color: #2b94ff;text-align: center;color: #ffffff;line-height: 32px"
                 @click="setData">
                确定
            </div>
            </div>
        </van-popup>
        <van-popup v-model="jsShow" position="bottom" lock-scroll overlay closeable :close-on-click-overlay="false"
                   style="height: 50%;">
            <div class="addmember">
                <span class="mbtb">结算</span>
            </div>
            <div style="padding-bottom: 40px">
                <div class="jisuanje">
                    <span>结算金额</span>
                    <div style="color: red">
                        <span style="font-size: 10px">¥</span>
                        <span style="font-size: 20px">{{totalAmount}}</span>
                    </div>
                </div>
                <div class="jisuanje">
                    <div class="mb-sex">
                        <el-radio-group v-model="radio" style="margin-top: 7px;">
                            <el-radio :label="1">开单</el-radio>
                            <el-radio :label="2" style="margin-left: -10px" v-if="bdqx">补单</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="srdate2" v-if="radio==2" @click="toShiJian('2')">{{kdDate}}</div>
                </div>
                <div class="jisuanfs">
                    <span>结算方式</span>
                    <van-radio-group v-model="payType" style="margin-top: 10px">
                        <van-radio :name="item.value" checked-color="#07c160" class="radio-btn"
                                   v-for="item in payTypes">{{item.name}}
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <div class="jiesuan-btn">
                <van-button type="default" :loading="isDisabled" class="jiesuanbtn" @click="jiesuan()">结算</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                deptId: '',
                token: '',

                totalAmount: 0,
                giveAmount: 0,
                mc: {},
                mcId: '',
                member: {},
                mcs: [],


                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',
                emps:[],
                empShow:false,

                radio: 1,
                kdDate: '请选择日期',
                jsShow: false,
                payTypes: [
                    {'name': '现金', 'value': 2},
                    // {'name': '微信', 'value': 3},
                    // {'name': '支付宝', 'value': 4},
                ],
                payType: 2,
                isDisabled: false,
                qxs:['bdqx'],
                bdqx:false,
            };
        },
        props:{
            memberId:String
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getPermissionList()
            this.getCards()
            this.getMemberInfo()
            this.getFwEmps()
            this.getDept()
        },
        methods: {
            async getPermissionList() {
                let data = {
                    token: this.token,
                    qxs:JSON.stringify(this.qxs)
                }
                let res = await this.$post("/fw/getPermissionList", data)
                if (res.permissionList.length > 0) {
                    this.permissionList = res.permissionList
                    if (this.permissionList.indexOf('bdqx') > -1) {
                        this.bdqx = true
                    }
                }
            },
            async getDept() {
                let res = await this.$get("/fw/getFwDeptInfo", {id: this.deptId});
                if (res.dept.isSqb!=null){
                    if (res.dept.isSqb==1){
                        this.payTypes= [
                            {'name': '现金', 'value': 2},
                            {'name': '微信', 'value': 3},
                            {'name': '支付宝', 'value': 4},
                        ]
                    }
                }
            },
            async getCards() {
                let data = {
                    memberId: this.memberId
                }
                let res = await this.$get("/fw/getFwMbmberCards", data);
                this.mcs = res.memberCards
            },
            async getMemberInfo() {
                let data = {
                    memberId: this.memberId,
                }
                let res = await this.$get("/fw/getFwMember", data)
                this.member = res.member
            },

            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },
            setEmp() {
                this.empShow = true
            },

            //设置员工
            setEmps(item, type) {
                let amount = 0
                    if (this.emps.length == 0) {
                        amount = this.totalAmount
                    }
                if (!item.check) {
                        this.emps.push({
                            empId: item.id,
                            empName: item.nickName,
                            ach: amount,
                            station: type,
                        })
                } else {
                    let index = this.emps.findIndex(it => it.empId == item.id);
                    this.emps.splice(index, 1)
                }
                item.check = !item.check
            },

            setData() {
                this.mc.emps = this.emps
                this.empShow = false
            },

            jiesuan() {
                this.isDisabled = true
                    this.mcRecharge()
            },

            jiesuancz() {
                if (this.mc && this.mc.id) {
                    let ach = 0;
                    this.emps.forEach(item => {
                        ach = parseFloat(ach) + parseFloat(item.ach)
                    })
                    if (ach > this.totalAmount) {
                        this.$notify({type: 'danger', message: '员工业绩大于充值金额!'});
                        return;
                    }
                    this.isDisabled = false
                    this.jsShow = true
                } else {
                    this.$notify({type: 'danger', message: '请先选择要充值的卡!'});
                }
            },
            async mcRecharge() {
                let data = {
                    mcId: this.mc.id,
                    mcName: this.mc.cardName,
                    xkCmn: this.mc.xkCmn,
                    empitems: JSON.stringify(this.emps),
                    totalAmount: this.totalAmount,
                    giveAmount: this.giveAmount,
                    payType: this.payType,
                    token: this.token,
                    kdType: this.radio,
                    kdDate: this.kdDate,
                };
                let res = await this.$post("/sw/mcRecharge", data);
                if (res.code == 200) {
                    this.isDisabled = false
                    this.close()
                    this.jsShow = false
                    this.$notify({type: 'success', message: '充值成功'});
                } else {
                    this.isDisabled = false
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            close(){
                    this.$emit('gbXk')
            },
            setCard(mcId) {
                this.mcs.forEach(item => {
                    if (item.id == mcId) {
                        this.mc = JSON.parse(JSON.stringify(item))
                    }
                })
                if (this.mc && this.mc.id) {
                    if (this.mc.cardAmount){
                        this.totalAmount = this.mc.cardAmount
                    }else {
                        this.totalAmount=0
                    }
                }
            },
            toShiJian(type) {
                this.dateType = type
                this.sjShow = true
            },
            guanbijs() {
                this.jsShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>


    /deep/ .el-card__header {
        padding: 10px;
        border-bottom: 0.02667rem solid #EBEEF5;
        box-sizing: border-box;
        font-size: 13px;
    }

    /deep/ .el-card__body {
        padding: 10px;
    }


    .srdate2 {
        display: block;
        width: 100px;
        line-height: 45px;
        text-align: right;
    }

    .ki {
        width: 60%;
    }

    .mb-sex {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff !important;
        border-radius: 0px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #ffffff;
        cursor: not-allowed;
    }

    .touxiang {
        height: 25px;
        width: 25px;
        float: left;
    }

    .bkmb {
        display: flex;
        flex-direction: row;
        height: 25px;
        font-size: 12px;
    }

    .cz-mcs {
        margin-top: 30px;
    }

    .cz-mcs-bt {
        display: block;
        font-size: 13px;
        height: 28px;
        line-height: 28px;
    }

    .cz-mc {
        padding-left: 10px;
    }

    .radioitem {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 28px;
        line-height: 28px;
    }

    .mc-je {
        display: flex;
        flex-direction: row;
        border-bottom: #EEEEEE solid 1px;
        font-size: 13px;
        height: 45px;
        line-height: 55px;
    }


    .xuanzebtn {
        margin-left: 10px;
        color: #cccccc;
        cursor: pointer;
        padding: 1px 5px;
        font-size: 11px;
        border: #dddddd solid 1px;
    }

    .jiesuan-btn {
        width: 100%;
        position: fixed;
        bottom: 0px;
    }

    .jiesuanbtn {
        width: 100%;
        text-align: center;
        height: 40px;
        background-color: red;
        color: #ffffff;
    }

    .jisuanje {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
        height: 43px;
        line-height: 50px;
        border-bottom: #EEEEEE solid 1px;
    }

    .jisuanfs {
        width: 90%;
        margin: auto;
        font-size: 13px;
        padding-top: 10px;
    }

    .radio-btn {
        height: 30px;
        font-size: 13px;
    }

    ::v-deep .van-radio__icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -ms-flex: none;
        flex: none;
        height: 1em;
        font-size: 13px;
        line-height: 1em;
        cursor: pointer;
        position: absolute;
        right: 30px;
    }

    .mc-emps {
        margin-top: 15px;
    }

    .mc-emp-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 23px;
        line-height: 23px;
    }

    .mc-emp-bt span {
        width: 50%;
        font-size: 13px;

    }

    .mc-emp {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 38px;
        line-height: 45px;
        border-bottom: #EEEEEE solid 1px;
    }

    .mc-emp span {
        width: 50%;
        font-size: 13px;
    }
    .czcard-name {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
    }
    .mcname{
        width: 70px;
    }
    .mcbalance{
        width: 110px;
    }
    .mcgive{
        width: 110px;
    }
</style>
